import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './BeautyBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const BANNER_TAG = `beauty_weeks`

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#CF1AB5',
    },
  },
});

export default function BeautyBanner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(BANNER_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(BANNER_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[BANNER_TAG]?.is_available_in_filter) {
    return null;
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
            >{t('beautyBanner.title')}</Typography>
            <Typography color="textPrimary">{t('beautyBanner.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('beautyBanner.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
